var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurso12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.65 135.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:gray;stroke-miterlimit:10;stroke-width:6.01px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167",
    "data-name": "Grupo 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_508",
    "data-name": "Trazado 508",
    className: "cls-1",
    d: "M52.77,8.43V40.79A5.09,5.09,0,0,1,48,46.2a3.53,3.53,0,0,1-.65,0H36.54a5.09,5.09,0,0,1-5.41-4.76c0-.22,0-.43,0-.65V8.43A5.09,5.09,0,0,1,35.89,3a3.53,3.53,0,0,1,.65,0H47.36a5.09,5.09,0,0,1,5.41,4.76,3.53,3.53,0,0,1,0,.65"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1201",
    "data-name": "Rect\\xE1ngulo 1201",
    className: "cls-1",
    x: 31.18,
    y: 3.02,
    width: 21.59,
    height: 43.18,
    rx: 6.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_509",
    "data-name": "Trazado 509",
    className: "cls-1",
    d: "M111.28,8.43V40.79a5.1,5.1,0,0,1-4.77,5.41,3.42,3.42,0,0,1-.64,0H95.05a5.09,5.09,0,0,1-5.41-4.76,3.53,3.53,0,0,1,0-.65V8.43A5.41,5.41,0,0,1,95.05,3h10.82a5.09,5.09,0,0,1,5.41,4.76c0,.22,0,.43,0,.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_510",
    "data-name": "Trazado 510",
    className: "cls-1",
    d: "M111.28,8.43V40.79a5.1,5.1,0,0,1-4.77,5.41,3.42,3.42,0,0,1-.64,0H95.05a5.09,5.09,0,0,1-5.41-4.76,3.53,3.53,0,0,1,0-.65V8.43A5.41,5.41,0,0,1,95.05,3h10.82a5.09,5.09,0,0,1,5.41,4.76C111.29,8,111.29,8.21,111.28,8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_511",
    "data-name": "Trazado 511",
    className: "cls-1",
    d: "M119.91,19.37h-8.63V40.79a5.1,5.1,0,0,1-4.77,5.41,3.42,3.42,0,0,1-.64,0H95.05a5.09,5.09,0,0,1-5.41-4.76,3.53,3.53,0,0,1,0-.65V19.37H52.77V40.79A5.09,5.09,0,0,1,48,46.2a3.53,3.53,0,0,1-.65,0H36.54a5.09,5.09,0,0,1-5.41-4.76c0-.22,0-.43,0-.65V19.37H19.71A16.56,16.56,0,0,0,3,35.8v80a16.59,16.59,0,0,0,16.11,17.05H119.91a16.59,16.59,0,0,0,16.74-16.43c0-.21,0-.42,0-.63V36.37a16.57,16.57,0,0,0-16.13-17h-.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_512",
    "data-name": "Trazado 512",
    className: "cls-1",
    d: "M119.91,19.37h-8.63V40.79a5.1,5.1,0,0,1-4.77,5.41,3.42,3.42,0,0,1-.64,0H95.05a5.09,5.09,0,0,1-5.41-4.76,3.53,3.53,0,0,1,0-.65V19.37H52.77V40.79A5.09,5.09,0,0,1,48,46.2a3.53,3.53,0,0,1-.65,0H36.54a5.09,5.09,0,0,1-5.41-4.76c0-.22,0-.43,0-.65V19.37H19.71A16.56,16.56,0,0,0,3,35.8v80a16.59,16.59,0,0,0,16.11,17.05H119.91a16.59,16.59,0,0,0,16.74-16.43c0-.21,0-.42,0-.63V36.37a16.57,16.57,0,0,0-16.13-17Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso12);
export default __webpack_public_path__ + "static/media/Recurso 12.2a1a2df994dd74e6e8286876802b0881.svg";
export { ForwardRef as ReactComponent };